// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gQkuF","content":"styles_content__2c0By","headerColumn":"styles_headerColumn__RhBHU"};